import React from "react";
import { motion } from "framer-motion";
import { FiAlertCircle } from "react-icons/fi";
import "./ErrorAlert.css";

/**
 * ErrorAlert Component
 *
 * Displays an error message in a sleek and friendly manner.
 *
 * Props:
 * - message (string): The error message to display.
 */
function ErrorAlert({ message }) {
  if (!message) return null;

  return (
    <motion.div
      className="error-alert"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <FiAlertCircle className="error-alert-icon" />
      <span className="error-alert-text">{message}</span>
    </motion.div>
  );
}

export default ErrorAlert; 